export function serviceKey(name) {
  return String(name || '').trim().toLowerCase();
}

/** men | women | unisex — from the DB gender, else guessed from the name/category. */
export function inferGender(svc) {
  const raw = String(svc?.gender || '').trim().toLowerCase();
  if (['male', 'm', 'man', 'men'].includes(raw)) return 'men';
  if (['female', 'f', 'woman', 'women', 'lady', 'ladies'].includes(raw)) return 'women';
  const blob = `${svc?.category || ''} ${svc?.name || ''}`.toLowerCase();
  if (/\b(women|woman|female|ladies|lady)\b/.test(blob)) return 'women';
  if (/\b(men|man|male|gents|gent|beard)\b/.test(blob)) return 'men';
  return 'unisex';
}

export function serviceCategory(svc) {
  const raw = String(svc?.category || '').trim();
  if (raw) return raw;
  const name = String(svc?.name || '').toLowerCase();
  if (/package|combo/.test(name)) return 'Package';
  if (/nail|manicure|pedicure|foot/.test(name)) return 'Nail';
  if (/massage|spa|therapy/.test(name)) return 'Massage';
  if (/facial|cleanup|bleach/.test(name)) return 'Skin';
  return 'Hair care';
}

/** Cart line from a saved bill item. */
export function lineFromItem(item, index = 0) {
  const meta = item?.metadata && typeof item.metadata === 'object' ? item.metadata : {};
  return {
    key: serviceKey(item.name) || `line-${index}`,
    name: item.name,
    unit_price: Number(item.unit_price) || 0,
    quantity: Number(item.quantity) || 1,
    stylist_name: item.stylist_name || '',
    service_id: meta.service_id || meta.catalog_id || null,
    category: meta.category || null,
    discount_percent: Number(meta.discount_percent) || 0,
    voucher_percent: Number(meta.voucher_percent) || 0,
    price_missing: Boolean(meta.price_missing) && !(Number(item.unit_price) > 0),
    requested_name: meta.requested_name || null,
  };
}

/** Bill item payload for PATCH /items from a cart line. */
export function itemFromLine(line) {
  return {
    name: line.name,
    quantity: Number(line.quantity) || 1,
    unit_price: Number(line.unit_price) || 0,
    stylist_name: line.stylist_name || null,
    metadata: {
      service_id: line.service_id || null,
      category: line.category || null,
      discount_percent: Number(line.discount_percent) || 0,
      voucher_percent: Number(line.voucher_percent) || 0,
      ...(line.requested_name ? { requested_name: line.requested_name } : {}),
      ...(line.price_missing && !(Number(line.unit_price) > 0) ? { price_missing: true } : {}),
    },
  };
}
